'use strict';

exports.__esModule = true;

var _lodash = require('lodash');

var _getOptionLabel = require('./getOptionLabel');

var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getInputText(_ref) {
  var activeItem = _ref.activeItem,
      labelKey = _ref.labelKey,
      multiple = _ref.multiple,
      selected = _ref.selected,
      text = _ref.text;

  if (multiple) {
    return text;
  }

  if (activeItem) {
    return (0, _getOptionLabel2['default'])(activeItem, labelKey);
  }

  var selectedItem = !!selected.length && (0, _lodash.head)(selected);
  if (selectedItem) {
    return (0, _getOptionLabel2['default'])(selectedItem, labelKey);
  }

  return text;
}

exports['default'] = getInputText;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/ssc-refer/lib/refer/utils/getInputText.js
// module id = 590
// module chunks = 0